export default "__VITE_ASSET__BCUVWAua__"